import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class GoogleLoginApiService {
  private httpClient: HttpClient;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  /**
  * Obtiene información del usuario de Google
  * @param Token de Google
  * @returns  información del usuario de Google
  */
  getUserInfo(token: string) {
    return this.httpClient.get(
      `https://www.googleapis.com/oauth2/v3/userinfo`,
      { params: { access_token: token } }
    );
  }

  /**
   * Obtiene el directorio de Google
   * @param token de Google
   * @param mail Correo del usuario
   * @returns  Directorio de Google
   */
  getDirectoryInfo(token: string, mail: string) {
    return this.httpClient.get(
      `https://content.googleapis.com/admin/directory/v1/users/${mail}`,
      {
        params: {
          access_token: token,
          viewType: "domain_public",
          projection: "full",
        },
      }
    );
  }

  /**
  * Obtiene informacion del token
  * @param token Token de Google
  * @returns  Información del token
  */
  getTokenInfo(token: string) {
    return this.httpClient.get(`https://www.googleapis.com/oauth2/v1/tokeninfo`, { params: { access_token: token } });
  }

}
